//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface AccountProfiles {
    totalRows: number;
    items: AccountProfile[];
}

export interface AccountProfile {
    accountProfileId: number;
    name: string | null;
    startPage: string | null;
    companyId: number;
    isTemplate: boolean;
    companyName: string | null;
    userCount: number;
}

export enum SortOrder {
    Descending = "Descending",
    Ascending = "Ascending",
}

export interface AccountProfilePermits {
    adminPermits: AccountProfilePermit[];
    repairsListsPermits: RepairsListsPermits;
    repairsDetailsPermits: AccountProfilePermit[];
    recordFiltersPermits: AccountProfilePermit[];
    reportPermits: AccountProfilePermit;
}

export interface AccountProfilePermit {
    accountProfilePermitId: number;
    name: string;
    groupName: string;
    permit: Permit | null;
    children: AccountProfilePermit[] | null;
    isActive: boolean;
}

export enum Permit {
    CORE_VEHICLES = "CORE_VEHICLES",
    CORE_SEARCH = "CORE_SEARCH",
    CORE_REPORTS = "CORE_REPORTS",
    CORE_ADMIN = "CORE_ADMIN",
    CORE_TOTALLOSS = "CORE_TOTALLOSS",
    GLOBAL_ADMIN = "GLOBAL_ADMIN",
    ADMIN_USERACCOUNTS = "ADMIN_USERACCOUNTS",
    ADD_ACTIVITY = "ADD_ACTIVITY",
    CONTACT_OWNER = "CONTACT_OWNER",
    CONTACT_REPAIRER = "CONTACT_REPAIRER",
    FLV_VEHICLE = "FLV_VEHICLE",
    FLV_CCAR = "FLV_CCAR",
    FLV_ECD = "FLV_ECD",
    FLV_STREAM = "FLV_STREAM",
    FLV_CREATED_DATE = "FLV_CREATED_DATE",
    FLV_CPD = "FLV_CPD",
    FLV_REPAIRER_GROUP = "FLV_REPAIRER_GROUP",
    FLV_DIARY_DATE = "FLV_DIARY_DATE",
    FLV_OWNER = "FLV_OWNER",
    FLV_FORMAL_STATUS = "FLV_FORMAL_STATUS",
    VIEW_SLA = "VIEW_SLA",
    FLV_REPAIRSTAGE = "FLV_REPAIRSTAGE",
    MUST_SEARCH_DUAL = "MUST_SEARCH_DUAL",
    NOWILDCARDS = "NOWILDCARDS",
    ALLOW_MANUAL_UPDATES = "ALLOW_MANUAL_UPDATES",
    CONNECTIONS_ADMIN = "CONNECTIONS_ADMIN",
    CA_QUEUE_CONTENTS_VIEW = "CA_QUEUE_CONTENTS_VIEW",
    CA_REPAIRERS_MANAGE = "CA_REPAIRERS_MANAGE",
    CA_MESSAGE_QUEUES_VIEW = "CA_MESSAGE_QUEUES_VIEW",
    CA_FNOL_VIEW = "CA_FNOL_VIEW",
    CA_MAINTENANCE_MESSAGES_VIEW = "CA_MAINTENANCE_MESSAGES_VIEW",
    CA_WP_VIEW = "CA_WP_VIEW",
    CA_REPAIRERS_VIEW = "CA_REPAIRERS_VIEW",
    CA_REPAIR_UPDATE_WP = "CA_REPAIR_UPDATE_WP",
    CA_REPAIR_UPDATE_JOB_STATUS = "CA_REPAIR_UPDATE_JOB_STATUS",
    CA_MAINTENANCE_MESSAGES_MANAGE = "CA_MAINTENANCE_MESSAGES_MANAGE",
    CA_REPAIRER_CONNECTIONS = "CA_REPAIRER_CONNECTIONS",
    CORE_CYCLETIME_V2 = "CORE_CYCLETIME_V2",
    ADMIN_QUEUE_CONTENTS = "ADMIN_QUEUE_CONTENTS",
    ADMIN_CONNECTIONS = "ADMIN_CONNECTIONS",
    FLV_TOTAL_DURATION = "FLV_TOTAL_DURATION",
    FLV_K2K_DURATION = "FLV_K2K_DURATION",
}

export interface RepairsListsPermits {
    corePermits: AccountProfilePermit[];
    fieldLevelPermits: AccountProfilePermit[];
}

export interface AccountProfileIdentity {
    accountProfileId: number;
}

export interface AccountProfilePermitIds {
    accountProfile: AccountProfile;
    permitIds: number[];
    recordFilterIds: number[];
    reportPermitIds: number[];
}

export interface WPMasterProfileIds {
    accountProfilePermitMasterIds: number[];
    accountProfileId: number;
}

export interface AccountProfileTemplate extends AccountProfile {
    alertType: AdminAccountProfileAlertType;
}

export enum AdminAccountProfileAlertType {
    None = 0,
    GlobalAdmin = 1,
}

export interface AdminAccountProfileWPMaster {
    accountProfileWPMasterId: number;
    name: string;
    alertType: AdminAccountProfileAlertType;
}

export interface Company {
    id: number;
    name: string | null;
    autoMainReference: boolean;
    lastMainReference: number;
    mainReferencePrefix: string | null;
    poP3Host: string | null;
    poP3Port: number | null;
    poP3UserName: string | null;
    poP3Password: string | null;
    poP3UseSSL: boolean | null;
    smtpHost: string | null;
    smtpPort: number | null;
    smtpReplyTo: string | null;
    smtpDisplayName: string | null;
    urlExtension: string | null;
    configPath: string | null;
    logTable: string | null;
    workStart: string | null;
    workEnd: string | null;
    locale: string | null;
    validSourceIP: string | null;
}

export interface CompanyIdentity {
    id: number;
}

export interface User {
    userId: number;
    userName: string | null;
    fullName: string | null;
    locale: string | null;
    email: string | null;
    companyId: number;
    companyName: string | null;
    startPage: StartPage;
    defaultUserAccountProfileId: number | null;
    selectedUserAccountProfile: UserProfile;
    userPermits: UserPermit[];
    recordFilters: UserRecordFilterPermit[];
    reportPermits: UserReportPermit[];
    userAccountProfiles: UserProfile[];
    idleTimeoutInMinutes: string | null;
}

export enum StartPage {
    Unknown = "Unknown",
    Dashboard = "Dashboard",
}

export interface UserProfile {
    userAccountProfileId: number;
    name: string | null;
}

export interface UserPermit {
    permitId: number;
    name: string | null;
    code: string | null;
}

export interface UserRecordFilterPermit {
    recordFilterId: number;
    code: string | null;
    name: string | null;
}

export interface UserReportPermit {
    file: string | null;
    title: string | null;
    description: string | null;
}

export interface HelpContext {
    message: string | null;
}

export interface CycleTimeResponseModel {
    shortName: string;
    fullName: string;
    claims: number | null;
    avgLabHrs: number | null;
    fnoL_Onsite: number | null;
    onSite_Started: number | null;
    started_Completed: number | null;
    completed_Delivered: number | null;
    key2Key: number | null;
    fnoL_Delivered: number | null;
}

export interface CycleTimeRequestModel {
    siteCode: string;
    manufacturer: string;
    stream: string;
    startDate: string;
    endDate: string;
    dataAccessProfileId: number | null;
    summaryType: number;
}

export interface DataAccessProfile {
    id: number;
    name: string | null;
    wpIdMask: string | null;
    companyId: number;
    companyName: string | null;
    userCount: number;
}

export interface WorkProviderFormalCode {
    formalCode: string | null;
    description: string | null;
    wpMasterId: string;
    workProviderId: string;
}

export interface DataAccessProfileIdentity {
    id: number;
}

export interface SiteCodeFormalCodeSearchResult {
    exists: boolean;
    allowed: boolean;
    status: UserWPSecurityPermitStatus;
}

export enum UserWPSecurityPermitStatus {
    None = "None",
    WPXReferenceOnly = "WPXReferenceOnly",
    PermitByWPIdMask = "PermitByWPIdMask",
    PermitByDataAccessDetail = "PermitByDataAccessDetail",
}

export interface SiteCodeFormalCodePair {
    siteCode: string;
    formalCode: string;
}

export interface ScheduleConfig {
    messages: MaintenanceMessage[];
    recurrenceIntervalInSeconds: number;
    warningBeforeInSeconds: number;
    cachedOn: string;
    cacheLifeTimeInSeconds: number;
}

export interface MaintenanceMessage {
    messageId: number;
    message: string;
    type: MaintenanceMessageType;
    validFrom: string;
    validTo: string;
}

export enum MaintenanceMessageType {
    Scheduled = "Scheduled",
    InProgress = "InProgress",
    Completed = "Completed",
}

export interface Repairer {
    repairerId: number;
    repairerGroup: string | null;
    repairerName: string | null;
    siteCode: string | null;
    manualUpdatesAllowed: boolean;
}

export interface RepairerGroupModel {
    groupName: string;
}

export interface RepairerMetaData {
    repairerId: number;
    repairerName: string;
    siteCode: string;
    repairerGroup: string;
    manualUpdatesAllowed: boolean;
    formalSiteCode: string;
}

export interface RepairerGroupsResult {
    repairerGroup: string;
    repairerGroupValue: string;
}

export interface Repairs {
    items: Repair[];
    totalRecordCount: number;
    dtgUpdated: string | null;
}

export interface Repair {
    repairId: number;
    repairCode: string | null;
    siteCode: string | null;
    repairerGroup: string | null;
    dtgUpdated: string | null;
    dtgCreated: string | null;
    dtgEcd: string | null;
    dtgCpd: string | null;
    dtgDelivered: string | null;
    dtgCompleted: string | null;
    dtgOnSite: string | null;
    diaryDate: string | null;
    formalStatus: FormalStatus | null;
    formalStatusDescription: string | null;
    workInProgressCode: string | null;
    schemeCode: string | null;
    claimReference: string | null;
    vehicleModel: string | null;
    vehicleMake: string | null;
    vehicleReg: string | null;
    repairStage: string | null;
    replacementVehicleStatus: ReplacementVehicleStatus;
    dtgReceived: string | null;
    totalDuration: number | null;
    k2KDuration: number | null;
}

export enum FormalStatus {
    Notified = "Notified",
    New = "New",
    Acknowledged = "Acknowledged",
    Liability = "Liability",
    BookedIn = "BookedIn",
    Authorized = "Authorized",
    EstimateMerged = "EstimateMerged",
    OnSite = "OnSite",
    PartsOrder = "PartsOrder",
    AwaitingParts = "AwaitingParts",
    Started = "Started",
    Completed = "Completed",
    Delivered = "Delivered",
    Finished = "Finished",
    Cancelled = "Cancelled",
    TotalLoss = "TotalLoss",
    TlPending = "TlPending",
    Redirected = "Redirected",
    Reopened = "Reopened",
    Unknown = "Unknown",
    UnknownStatus = "UnknownStatus",
}

export enum ReplacementVehicleStatus {
    NotRequired = "NotRequired",
    IsRequired = "IsRequired",
    AssignedOut = "AssignedOut",
    AssignedReturned = "AssignedReturned",
    Invalid = "Invalid",
}

export interface ClaimSummary {
    repairId: number;
    claimId: number | null;
    repairCode: string | null;
    formalStatusID: number | null;
    claimReference: string | null;
    ownerExcess: number | null;
    ownerExcessPaid: number | null;
    possibleTL: boolean | null;
    isVehicleDriveable: boolean | null;
    ownerName: string | null;
    vehicle: string | null;
    vehicleRegistration: string | null;
    stream: string | null;
    milestone: Milestone | null;
    replacementVehicle: ReplacementVehicle | null;
    repairer: RepairerInfo | null;
    invoice: Invoice | null;
    serviceLevelAgreements: ServiceLevelAgreement[];
    activities: Activity[];
}

export interface Milestone {
    partsOrderedDate: string | null;
    partsInDate: string | null;
    createdDate: string | null;
    updatedDate: string | null;
    insAuthorisedDate: string | null;
    firstActivityDate: string | null;
    notificationDate: string;
    incidentDate: string | null;
    estimationDate: string | null;
    bookedOutDate: string | null;
    bookedInDate: string | null;
    onSiteDate: string | null;
    startedDate: string | null;
    completedDate: string | null;
    deliveredDate: string | null;
    cpdChangeCount: number | null;
}

export interface ReplacementVehicle {
    courtesyMake: string | null;
    courtesyModel: string | null;
    replacementReg: string | null;
    dateIn: string | null;
    dateOut: string | null;
}

export interface RepairerInfo {
    name: string | null;
    group: string | null;
    requiresManualRepairUpdate: boolean;
}

export interface Invoice {
    firstInvoiceDate: string | null;
    labourHours: number | null;
    invoicedLabour: number | null;
    invoicedParts: number | null;
    invoicedPaint: number | null;
    invoicedOther: number | null;
    invoicedTax: number | null;
    invoicedTotal: number | null;
    ownerExcess: number | null;
    ownerExcessPaid: number | null;
}

export interface ServiceLevelAgreement {
    title: string | null;
    description: string | null;
    startDate: string;
    expectedValue: string | null;
    actualValue: string | null;
    status: string | null;
    icon: string | null;
}

export interface Activity {
    icon: string | null;
    activityCategory: string | null;
    operator: string | null;
    activityType: string | null;
    activityDate: string;
    message: string | null;
    complaint: boolean;
    externalShortCode: string | null;
}

export interface ReasonLogOfRepairerReason {
    reasonCode: RepairerReason;
    additionalNotes: string | null;
}

export enum RepairerReason {
    BookIn = "BookIn",
    BookOut = "BookOut",
    CustomerUpdate = "CustomerUpdate",
    PoorData = "PoorData",
    RepairerStaff = "RepairerStaff",
    ReplacementVehicle = "ReplacementVehicle",
    RepairQuality = "RepairQuality",
    Other = "Other",
}

export interface ReasonLogOfOwnerReason {
    reasonCode: OwnerReason;
    additionalNotes: string | null;
}

export enum OwnerReason {
    BookIn = "BookIn",
    BookOut = "BookOut",
    CustomerUpdate = "CustomerUpdate",
    PoorData = "PoorData",
    RepairerStaff = "RepairerStaff",
    ReplacementVehicle = "ReplacementVehicle",
    RepairQuality = "RepairQuality",
    Other = "Other",
}

export interface RepairerDetails {
    name: string | null;
    repairerGroup: string | null;
    telephone: string | null;
    email: string | null;
}

export interface Owner {
    firstName: string | null;
    surname: string | null;
    telephoneWork: string | null;
    telephoneHome: string | null;
    telephoneMobile: string | null;
    email: string | null;
}

export interface AddActivity {
    userName: string;
    activityComment: string;
    isComplaint: boolean;
}

export interface RepairManualUpdate {
    milestone: Milestone | null;
    invoice: Invoice | null;
    replacementVehicle: ReplacementVehicle | null;
    claimDetail: ClaimDetail | null;
}

export interface ClaimDetail {
    possibleTL: boolean | null;
    isVehicleDriveable: boolean | null;
    formalStatus: string | null;
}

export interface BaseUserAccount {
    id: number;
    userName: string | null;
    firstName: string | null;
    surname: string | null;
    email: string | null;
    companyId: number;
    companyName: string | null;
    teamName: string | null;
    isDisabled: boolean;
    isLocked: boolean;
    createdDate: string | null;
    expiryDate: string | null;
    lastLoginDate: string | null;
    invalidLoginAttempts: number;
    usageCount: number;
    dataAccessProfileName: string;
}

export interface UserAccount extends BaseUserAccount {
    hasPassword: boolean;
    accountProfileName: string | null;
    locale: string | null;
    mobile: string | null;
    telephone: string | null;
    defaultUserAccountProfileId: number | null;
    allowIPOverride: boolean;
    accountLockedDate: string | null;
    externalAuthenticationId: string | null;
    dataAccessProfileId: number;
    isGlobalAdmin: boolean;
    skipMFA: boolean | null;
}

export interface Engineer {
    repairId: number;
    engineerName: string | null;
    notes: string | null;
    engineerInspectionDTG: string;
}

export interface DtlItem {
    repairId: number;
    repairCode: string;
    dtgUpdated: string | null;
    formalStatus: string;
    dtgCreated: string | null;
    schemeCode: string;
    claimReference: string;
    vehicleMake: string;
    vehicleReg: string;
    repairStage: string;
    dtgEcd: string | null;
    onSite: number;
    delivered: number;
    repairerGroup: string;
}

export interface Measure30Result {
    measureName: string;
    c0: number | null;
    c1: number | null;
    c2: number | null;
    c3: number | null;
    c4: number | null;
    c5: number | null;
    c6: number | null;
    c7: number | null;
    c8: number | null;
    c9: number | null;
    c10: number | null;
    c11: number | null;
    c12: number | null;
    c13: number | null;
    c14: number | null;
    c15: number | null;
    c16: number | null;
    c17: number | null;
    c18: number | null;
    c19: number | null;
    c20: number | null;
    c21: number | null;
    c22: number | null;
    c23: number | null;
    c24: number | null;
    c25: number | null;
    c26: number | null;
    c27: number | null;
    c28: number | null;
    c29: number | null;
    c30: number | null;
    c31: number | null;
}

export interface NPSDetailReport04 {
    name: string;
    siteCode: string;
    schemeCode: string;
    regmark: string;
    claimReference: string;
    claimId: number | null;
    surveyDate: string;
    responseDate: string | null;
    score: number | null;
    responseText: string;
    response: string;
    startDate: string | null;
    endDate: string | null;
    repairerGroup: string;
}

export interface NPSDetailReport04Request {
    startDate: string;
    endDate: string;
    repairSites: string;
    schemeCodes: string;
    npsScore: string;
    groupingValue: string;
    reportGrouping: string;
}

export interface NPSSummaryReport04 {
    schemecode: string;
    siteName: string;
    siteCode: string;
    noResponse: number | null;
    detractor: number | null;
    passive: number | null;
    promotor: number | null;
    groupingValue: number | null;
    totalResponses: number | null;
    totalRows: number | null;
    dateStarted: string | null;
    dateEnded: string | null;
    npsScore: number | null;
    monthYearGroupings: NPSSummaryReport04MonthYearGrouping[];
    repairerGroup: string;
}

export interface NPSSummaryReport04MonthYearGrouping {
    name: string;
    value: number | null;
}

export interface NPSSummaryReport04Request {
    startDate: string;
    endDate: string;
    repairSites: string;
    schemeCodes: string;
    reportingGroup: string;
    noOfDateGroups: number | null;
    dateRangeOption: string;
}

export interface CycleTimeReportExV2 {
    repairer: string;
    siteCode: string;
    repairerGroup: string;
    activeWebID: string;
    registration: string;
    stream: string;
    manufacturer: string;
    fnolToOnsite: number | null;
    onSiteToStarted: number | null;
    startedToCompleted: number | null;
    completedToDelivered: number | null;
    keyToKey: number | null;
    fnolToDelivered: number | null;
    fnolToInvoiced: number | null;
    hours: number | null;
    affectsCycleTime: number;
    createdDTG: string;
}

export interface WorkInProgress {
    repairerName: string;
    repairerGroup: string;
    activeWebId: string;
    schemeCode: string;
    registration: string;
    claimReference: string;
    status: string;
    dtgCreated: string | null;
    dtgOnsite: string | null;
    dtgAuthorised: string | null;
    dtgPartsOrdered: string | null;
    dtgEstimatedCompletion: string | null;
    dtgReplacementVehicleKeysOut: string | null;
    replacementVehicleKeysOut: string;
    replacementVehicleModel: string;
    dtgLastDataUpdate: string | null;
    dtgLastStatusChange: string | null;
    dtgLastActivity: string | null;
    lastActivityBy: string;
    dtgLatestPdelay: string | null;
    statusAge: number | null;
    dataAge: number | null;
    lastActivityAge: number | null;
    reportMode: string;
}

export interface SmsReport {
    schemeCode: string;
    repairID: number;
    regMark: string;
    smsBody: string;
    repairerName: string;
    messageDate: string | null;
    messageTime: string | null;
    messageType: string;
    messageDescription: string;
    claimReference: string;
}

export interface SMSBillingReport {
    repairer: string;
    claimReference: string;
    registration: string;
    tranmissionDTG: string;
    smsBody: string;
    network: string;
    repairID: number;
    creditCount: number | null;
}

export interface NARGControlSheetV05 {
    claimReference: string;
    bodyshop: string;
    activeWebID: string;
    status: string;
    claimSource: string;
    liability: string;
    isThirdParty: boolean | null;
    createdDate: string | null;
    ownerName: string;
    manufacturer: string;
    model: string;
    regmark: string;
    notificationSent: number | null;
    notificationAcknowledged: number | null;
    bookingInDate: string | null;
    estimatedDTG: string | null;
    labourHours: number | null;
    possibleTotalLoss: boolean | null;
    engineerInstructedDate: number | null;
    declaredTotalLossDate: number | null;
    confirmedOnSiteDate: string | null;
    estimatedCompletionDate: string | null;
    partsOrderedDate: string | null;
    partsArrivedDate: string | null;
    workStartedDate: string | null;
    actualCompletionDate: string | null;
    deliveredDate: string | null;
    invoiceDate: string | null;
    hashTags: string;
}

export interface NARGControlSheetV05Request {
    startDate: string;
    endDate: string;
    schemeCodeList: string;
}

export interface VehiclesOnsiteReport {
    repairerName: string;
    schemeCode: string;
    regMark: string;
    claimID: number | null;
    localStatus: string;
    manufacturer: string;
    model: string;
    dtgCreated: string | null;
    dtgBookedIn: string | null;
    dtgOnSite: string | null;
    courtesyMake: string;
    replacementReg: string;
    claimReference: string;
}

export interface SLAPerformance {
    workProviderName: string;
    slaTitle: string;
    slaDescription: string;
    timeType: string;
    repairerGroup: string;
    repairerName: string;
    repairCode: string;
    regMark: string;
    claimReference: string;
    trackingStartDTG: number | null;
    startDTG: string | null;
    breachDTG: string | null;
    completedDTG: string | null;
    slaDuration: number | null;
    count: number;
    slaType: number | null;
    expectedDataValue: string;
    actualDataValue: string;
    dataSuccess: number | null;
    slaCompleted: boolean | null;
    slaWarning: number | null;
    slaBreach: number | null;
    hashtag: string;
    eol: string;
    stream: string;
}

export interface SLAPerformanceRequest {
    repairerGroups: string;
    siteCodes: string;
    startDate: string;
    endDate: string;
}

export interface InvoiceReport {
    activeWebID: string;
    repairerCode: string;
    repairer_Name: string;
    created_Date: string | null;
    finalisationDate: string | null;
    scheme_Code: string;
    claimReference: string;
    registration: string;
    reportBasedOn: string;
}

export interface B2BRestQueueMessage {
    queue: string;
    queueMessageId: number;
    messageGuid: string;
    messageType: string;
    messageContent: string;
    messageHash: string;
    sender: string;
    senderReference: string;
    recipient: string;
    repairerSiteCode: string;
    repairerName: string;
    entryDate: string;
    readDate: string | null;
}

export interface GoodWillReport {
    pinetreeId: string;
    claimReference: string;
    schemeCode: string;
    ownerName: string;
    ownerPostCode: string;
    regMark: string;
    isValid: number;
    goodwillAmount: number;
    comments: string;
    goodwillDays: number;
    dtgCalculated: string;
}

export interface TotalLossReport {
    engineerName: string;
    onsiteDTG: string | null;
    engineerDate: string | null;
    repairerName: string;
    postcode: string;
    claimReference: string;
    regMark: string;
    manufacturer: string;
    model: string;
    activeWebId: number;
}

export interface CoveaReport {
    repairSatus: CoveaRepairStatus[] | null;
    mobileCount: CoveaMobileCount | null;
}

export interface CoveaRepairStatus {
    repairer: string | null;
    regmark: string | null;
    claimReference: string | null;
    onSiteDate: string | null;
    smsSentDate: string | null;
    termsAcceptedDate: string | null;
    numberOfHits: number | null;
    repairCode: string;
}

export interface CoveaMobileCount {
    recs: number | null;
    repairCount: number | null;
    mobileNumbers: number | null;
}

export interface NPSBillingReport {
    billingCount: number | null;
    siteCode: string | null;
    schemeCode: string | null;
    repairerName: string | null;
    repairerGroup: string | null;
    startDate: string | null;
    endDate: string | null;
}

export interface SsrsReportParameter {
    name: string | null;
    label: string | null;
    type: ParameterTypeEnum;
}

export enum ParameterTypeEnum {
    Boolean = 0,
    DateTime = 1,
    Integer = 2,
    Float = 3,
    String = 4,
}

export interface RenderExtension {
    name: string | null;
    localizedName: string | null;
    extension: string | null;
}

export interface ActiveWebUsageReport {
    userAccountId: number;
    fullName: string;
    profile: string;
    lastused: string | null;
    reportYear: number;
    reportMonth: number;
    searchesPriorMonthMinus1: number;
    searchesPriorMonth: number;
    searchesThisMonth: number;
    ytdSearchCount: number;
    feedbackCount: number;
    accountLockedDate: string | null;
    disabled: boolean;
}

export interface FeedbackReport {
    activeWebID: string;
    registration: string;
    claimReference: string;
    repairerName: string;
    feedbackDate: string;
    feedbackComment: string;
    feedbackType: string;
    userID: string;
}

export interface AllSiteConnection {
    systemType: string;
    repairerID: number;
    siteCode: string;
    address: string;
    postcode: string;
    name: string;
    accountStatus: string;
    allianz: string;
    capsOutboundConnections: string;
    coveaCode: string;
    dlgNetwork: string;
    esure: string;
    lvConnection: string;
    nargNetwork: string;
    nnsSiteCode: string;
    rsa: string;
    itasNetwork: string;
    capsInboundConnection: string;
    kindertons: string;
    audatex: string;
    repairerGroup: string;
    admiral: string;
    subscriptionType: string;
}

export interface Key2KeyDataRSA {
    code: string;
    year: number | null;
    month: number | null;
    key2Key: number | null;
    sumLabourHours: number | null;
    avgLabourHours: number | null;
    avgOnsiteToStarted: number | null;
    avgStartToCompleted: number | null;
    avgCompletedToDelivered: number | null;
}

export interface GetKey2KeyDataLVOWN {
    code: string;
    year: number | null;
    month: number | null;
    key2Key: number | null;
    sumLabourHours: number | null;
    avgLabourHours: number | null;
    avgOnsiteToStarted: number | null;
    avgStartToCompleted: number | null;
    avgCompletedToDelivered: number | null;
    avgCreatedToOnsite: number | null;
}

export interface CSITriggerReport {
    registration: string;
    claimReference: string;
    manufacturer: string;
    model: string;
    ownerName: string;
    ownerEmail: string;
    ownerMobile: string;
    dateReturned: string | null;
    elapsedK2K: number | null;
    name: string;
    comments: string;
}

export interface CoreMIReport {
    name: string;
    siteCode: string;
    repairerGroup: string;
    stream: string;
    insurerName: string;
    claimReference: string;
    regMark: string;
    claimId: number | null;
    status: string;
    statusDTG: string | null;
    manufacturer: string;
    model: string;
    vehicleMobile: string;
    labourHours: number | null;
    labourCost: number | null;
    partsCost: number | null;
    paintCost: number | null;
    otherCost: number | null;
    totalCost: number | null;
    ownerExcess: number | null;
    courtesyCarProvided: string;
    courtesyCar: string;
    courtesyCarOut: boolean | null;
    ownerMobileNumber: string;
    ownerEmail: string;
    createdDate: string | null;
    bookedInDate: string | null;
    onSiteDate: string | null;
    partsOrderedDate: string | null;
    workStartedDate: string | null;
    workCompletedDate: string | null;
    bookedOutDate: string | null;
    offSiteDate: string | null;
    invoiceDate: string | null;
    ecdDate: string | null;
    liabilityImpact: string;
    initialBookInDate: string | null;
    bookInDateChanges: number | null;
    initialBookOutDate: string | null;
    bookOutDateChanges: number | null;
    initialECDDate: string | null;
    ecdDateChanges: number | null;
    cT_FNOL_OnSite: number | null;
    cT_Key_2_Key: number | null;
    cT_CycleTime: number | null;
    within15Days: string;
    within21Days: string;
    webPortalUsage: number | null;
    smsMessages: number | null;
    hashTags: string;
    initialOnSiteDate: string | null;
    initialWorkCompletedDate: string | null;
    replacementVehicleCode: string;
    dtgFnol: string | null;
    dtgFirstActivity: string | null;
    vehicleStillOnSite: boolean | null;
}

export interface VolumeTrendsReport {
    yearSelected: string;
    day: string | null;
    volume: number | null;
    measure: string;
}

export interface NotificationVolumeResponseModel {
    repairer: string;
    volume: number;
}

export interface CombinedBillingReport {
    summary: CombinedBillingReportSummary[];
    details: CombinedBillingReportDetail[];
}

export interface CombinedBillingReportSummary {
    workProvider: string;
    npsBillingCount: number | null;
    smsBillingCount: number | null;
    emailBillingCount: number | null;
}

export interface CombinedBillingReportDetail {
    repairerName: string;
    repairerGroup: string;
    schemeCode: string;
    workProvider: string;
    billingCount: number | null;
    billingCategory: string;
    siteCode: string;
    startDate: string | null;
    endDate: string | null;
}

export interface EmailReport {
    repairerName: string;
    repairerGroup: string;
    schemeCode: string;
    workProvider: string;
    siteCode: string;
    emailSentDate: string;
    subject: string;
    regmark: string;
}

export interface WPSiteConnection {
    systemType: string;
    siteCode: string;
    address: string;
    postcode: string;
    name: string;
    repairerGroup: string;
    connectionDetails: string;
    capsCodes: string;
}

/** A protocol response */
export interface ProtocolResponse {
    httpResponse: string;
    /** Gets the raw protocol response (if present). */
    raw: string | null;
    /** Gets the protocol response as JSON (if present). */
    json: any | null;
    /** Gets the exception (if present). */
    exception: Exception | null;
    /** Gets a value indicating whether an error occurred. */
    isError: boolean;
    /** Gets the type of the error. */
    errorType: ResponseErrorType;
    /** Gets or sets an explicit error message. */
    errorMessage: string | null;
    /** Gets the HTTP status code - or 0 when HttpResponse is null. */
    httpStatusCode: HttpStatusCode;
    /** Gets the HTTP error reason - or null when HttpResponse is null. */
    httpErrorReason: string | null;
    /** Gets the error. */
    error: string | null;
    /** The returned DPoP nonce header. */
    dPoPNonce: string | null;
}

/** Models a response from an OpenID Connect/OAuth 2 token endpoint */
export interface TokenResponse extends ProtocolResponse {
    /** Gets the access token. */
    accessToken: string | null;
    /** Gets the identity token. */
    identityToken: string | null;
    /** Gets the scope. */
    scope: string | null;
    /** Gets the issued token type. */
    issuedTokenType: string | null;
    /** Gets the type of the token. */
    tokenType: string | null;
    /** Gets the refresh token. */
    refreshToken: string | null;
    /** Gets the error description. */
    errorDescription: string | null;
    /** Gets the expires in. */
    expiresIn: number;
}

export interface Exception {
    targetSite: MethodBase | null;
    message: string;
    data: any[];
    innerException: Exception | null;
    helpLink: string | null;
    source: string | null;
    hResult: number;
    stackTrace: string | null;
}

export interface MemberInfo {
    memberType: MemberTypes;
    name: string;
    declaringType: string | null;
    reflectedType: string | null;
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    metadataToken: number;
}

export interface MethodBase extends MemberInfo {
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
}

export enum MethodAttributes {
    PrivateScope = 0,
    ReuseSlot = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    MemberAccessMask = 7,
    UnmanagedExport = 8,
    Static = 16,
    Final = 32,
    Virtual = 64,
    HideBySig = 128,
    NewSlot = 256,
    VtableLayoutMask = 256,
    CheckAccessOnOverride = 512,
    Abstract = 1024,
    SpecialName = 2048,
    RTSpecialName = 4096,
    PinvokeImpl = 8192,
    HasSecurity = 16384,
    RequireSecObject = 32768,
    ReservedMask = 53248,
}

export enum MethodImplAttributes {
    IL = 0,
    Managed = 0,
    Native = 1,
    OPTIL = 2,
    CodeTypeMask = 3,
    Runtime = 3,
    ManagedMask = 4,
    Unmanaged = 4,
    NoInlining = 8,
    ForwardRef = 16,
    Synchronized = 32,
    NoOptimization = 64,
    PreserveSig = 128,
    AggressiveInlining = 256,
    AggressiveOptimization = 512,
    InternalCall = 4096,
    MaxMethodImplVal = 65535,
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export interface RuntimeMethodHandle {
    value: IntPtr;
}

export interface IntPtr {
}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export interface Module {
    assembly: Assembly;
    fullyQualifiedName: string;
    name: string;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export interface Assembly {
    definedTypes: TypeInfo[];
    exportedTypes: string[];
    codeBase: string | null;
    entryPoint: MethodInfo | null;
    fullName: string | null;
    imageRuntimeVersion: string;
    isDynamic: boolean;
    location: string;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[];
    escapedCodeBase: string;
    manifestModule: Module;
    modules: Module[];
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export interface Anonymous {
    genericTypeParameters: string[];
    declaredConstructors: ConstructorInfo[];
    declaredEvents: EventInfo[];
    declaredFields: FieldInfo[];
    declaredMembers: MemberInfo[];
    declaredMethods: MethodInfo[];
    declaredNestedTypes: TypeInfo[];
    declaredProperties: PropertyInfo[];
    implementedInterfaces: string[];
}

export interface TypeInfo extends Anonymous {

    [key: string]: any;
}

export interface ConstructorInfo extends MethodBase {
    memberType: MemberTypes;
}

export interface EventInfo extends MemberInfo {
    memberType: MemberTypes;
    attributes: EventAttributes;
    isSpecialName: boolean;
    addMethod: MethodInfo | null;
    removeMethod: MethodInfo | null;
    raiseMethod: MethodInfo | null;
    isMulticast: boolean;
    eventHandlerType: string | null;
}

export enum EventAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    ReservedMask = 1024,
}

export interface MethodInfo extends MethodBase {
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: string;
    returnTypeCustomAttributes: ICustomAttributeProvider;
    genericParameterCount: number;
}

export interface ParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name: string | null;
    parameterType: string;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue: any | null;
    rawDefaultValue: any | null;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export interface CustomAttributeData {
    attributeType: string;
    constructor: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[];
    namedArguments: CustomAttributeNamedArgument[];
}

export interface CustomAttributeTypedArgument {
    argumentType: string;
    value: any | null;
}

export interface CustomAttributeNamedArgument {
    argumentType: string;
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string;
    isField: boolean;
}

export interface ICustomAttributeProvider {
}

export interface FieldInfo extends MemberInfo {
    memberType: MemberTypes;
    attributes: FieldAttributes;
    fieldType: string;
    isInitOnly: boolean;
    isLiteral: boolean;
    isNotSerialized: boolean;
    isPinvokeImpl: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    fieldHandle: RuntimeFieldHandle;
}

export enum FieldAttributes {
    PrivateScope = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    FieldAccessMask = 7,
    Static = 16,
    InitOnly = 32,
    Literal = 64,
    NotSerialized = 128,
    HasFieldRVA = 256,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasFieldMarshal = 4096,
    PinvokeImpl = 8192,
    HasDefault = 32768,
    ReservedMask = 38144,
}

export interface RuntimeFieldHandle {
    value: IntPtr;
}

export interface PropertyInfo extends MemberInfo {
    memberType: MemberTypes;
    propertyType: string;
    attributes: PropertyAttributes;
    isSpecialName: boolean;
    canRead: boolean;
    canWrite: boolean;
    getMethod: MethodInfo | null;
    setMethod: MethodInfo | null;
}

export enum PropertyAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasDefault = 4096,
    Reserved2 = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 62464,
}

export enum SecurityRuleSet {
    None = "None",
    Level1 = "Level1",
    Level2 = "Level2",
}

export interface ModuleHandle {
    mdStreamVersion: number;
}

/** Various reasons for a protocol endpoint error */
export enum ResponseErrorType {
    None = 0,
    Protocol = 1,
    Http = 2,
    Exception = 3,
    PolicyViolation = 4,
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 300,
    MovedPermanently = 301,
    Moved = 301,
    Found = 302,
    Redirect = 302,
    SeeOther = 303,
    RedirectMethod = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    RedirectKeepVerb = 307,
    PermanentRedirect = 308,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    MisdirectedRequest = 421,
    UnprocessableEntity = 422,
    UnprocessableContent = 422,
    Locked = 423,
    FailedDependency = 424,
    UpgradeRequired = 426,
    PreconditionRequired = 428,
    TooManyRequests = 429,
    RequestHeaderFieldsTooLarge = 431,
    UnavailableForLegalReasons = 451,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
    VariantAlsoNegotiates = 506,
    InsufficientStorage = 507,
    LoopDetected = 508,
    NotExtended = 510,
    NetworkAuthenticationRequired = 511,
}

export interface ServiceAccountModel {
    userAccountId: number;
    username: string;
}

export interface UserAccountProfile {
    id: number;
    userAccountId: number;
    accountProfileId: number;
    name: string | null;
    startPage: string | null;
    companyId: number;
    isTemplate: boolean;
    companyName: string | null;
}

export interface UserIdentity {
    id: number;
}

export interface UserAccountProfilesUpdate {
    accountProfileIds: number[];
    defaultAccountProfileId: number;
}

export interface WorkProvider {
    wpDescription: string;
    wpMasterId: number;
}

export interface WorkProviderScheme {
    schemeCode: string;
    description: string;
}

export interface WorkProviderGroup {
    groupName: string;
    workProvider: string;
}

function jsonParse(json: any, reviver?: any) {
    json = JSON.parse(json, reviver);

    var byid: any = {};
    var refs: any = [];
    json = (function recurse(obj: any, prop?: any, parent?: any) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        
        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        } else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        
        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        } else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }

        return obj;
    })(json);

    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }

    return json;
}

function createInstance<T>(data: any, mappings: any, type: any): T | null {
  if (!mappings)
    mappings = [];
  if (!data)
    return null;

  const mappingIndexName = "__mappingIndex";
  if (data[mappingIndexName])
    return <T>mappings[data[mappingIndexName]].target;

  data[mappingIndexName] = mappings.length;

  let result: any = new type();
  mappings.push({ source: data, target: result });
  result.init(data, mappings);
  return result;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}